(function () {
  if (window.__ghostCouponCopyInit) return;
  window.__ghostCouponCopyInit = true;

  function fallbackCopy(text) {
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        document.body.removeChild(textarea);
      }
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return fallbackCopy(text);
  }

  function getCopyTargets(trigger) {
    var group = trigger.closest('[data-ghost-coupon-copy-group]');
    if (group) {
      return group.querySelectorAll('[data-ghost-coupon-copy]');
    }

    return [trigger];
  }

  function markCopied(targets, copiedLabel) {
    targets.forEach(function (target) {
      var copyLabel = target.getAttribute('data-copy-label') || 'Copy code';

      target.classList.add('is-copied');
      target.setAttribute('aria-label', copiedLabel);

      window.clearTimeout(target.__ghostCopyTimeout);
      target.__ghostCopyTimeout = window.setTimeout(function () {
        target.classList.remove('is-copied');
        target.setAttribute('aria-label', copyLabel);
      }, 2000);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ghost-coupon-copy]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    var code = trigger.getAttribute('data-coupon-code');
    if (!code) return;

    var copiedLabel = trigger.getAttribute('data-copied-label') || 'Copied';
    var targets = getCopyTargets(trigger);

    copyText(code)
      .then(function () {
        markCopied(targets, copiedLabel);
      })
      .catch(function () {
        /* Clipboard blocked — leave controls unchanged */
      });
  });
})();
